import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { SliceKeys } from "@sso/constant";
import { RootState } from "@sso/store";
import { DrawerStateType } from "@sso/types";

const initialState: DrawerStateType = {
  open: true,
  selectedItem: "products",
};

export const DrawerSlice = createSlice({
  name: SliceKeys.DRAWER,
  initialState: initialState,
  reducers: {
    setDrawerOpen: (drawer, action: PayloadAction<boolean>) => {
      drawer.open = action.payload;
    },
    setDrawerItem: (drawer, action: PayloadAction<string>) => {
      drawer.selectedItem = action.payload;
    },
  },
});

export const { setDrawerOpen, setDrawerItem } = DrawerSlice.actions;
export const selectDrawerState = (state: RootState) => state.drawer;
export default DrawerSlice.reducer;
